import { useSelector } from 'react-redux';

import { getVehiclesList } from '../store/selectors';

const useMakes = () => {
  const vehiclesList = useSelector(getVehiclesList);

  return vehiclesList.map(({ make }) => ({ title: make, value: make }));
};

export { useMakes };
